import { Component, Input, OnInit } from '@angular/core';
import { UserAvailability } from 'server/shared/models/userAvailability';
import { AvailabilityStatusEnum } from 'server/shared/models/availabilityStatusEnum';

@Component({
  selector: 'app-availability-icon',
  templateUrl: './availability-icon.component.html',
  styleUrls: ['./availability-icon.component.scss'],
})
export class AvailabilityIconComponent implements OnInit {
  @Input() availability?: UserAvailability;
  @Input() size: 'normal' | 'small' = 'normal';
  working = false;

  constructor() {}

  ngOnInit(): void {
    this.working =
      (this.availability?.shifts &&
        Object.keys(this.availability.shifts).some(
          (shiftKey) =>
            //  @ts-ignore
            this.availability?.shifts?.[shiftKey] ===
            AvailabilityStatusEnum.WORKING,
        )) ||
      false;
  }
}
